var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import Icon from "@ant-design/icons";
var ErrorSvg = /* @__PURE__ */ __name(function ErrorSvg2() {
  return /* @__PURE__ */ React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M27.311 30.604l-11.187-5.476-7.2 5.471 0.889-7.409-8.298-1.689 6.422-3.96-4.169-5.822 7.733 1.236 2.138-11.022 4.444 10.116 8.582-3.689-3.876 7.449 8.067 2.48-8.32 3.316zM7.462 20.444l4.787 0.978-0.502 4.244 4.129-3.133 6.267 3.067-2.729-5.156 4.76-1.898-4.591-1.396 2.222-4.293-4.889 2.102-2.453-5.6-1.187 6.133-4.6-0.742 2.436 3.431z"
  }));
}, "ErrorSvg");
var ErrorIcon = /* @__PURE__ */ __name(function ErrorIcon2(props) {
  return /* @__PURE__ */ React.createElement(Icon, _extends({
    component: ErrorSvg
  }, props));
}, "ErrorIcon");
export {
  ErrorIcon
};
